export default {
  grid: 'dt.lobby.grid',
  header: {
    toggle: {
      grid: {
        view: 'dt.lobby.header.toggle.grid.view',
      },
      table: {
        view: 'dt.lobby.header.toggle.table.view',
      },
    },
  },
  table: 'dt.lobby.table',
};
